import React, { useEffect, useState, useRef } from "react"
import { Modal, Form, Input, DatePicker, Select, InputNumber, Alert, Upload, Button, message } from "antd"
import { UploadOutlined } from "@ant-design/icons"
import { API } from "../utils/API"
import moment from "moment"
import TextArea from "antd/lib/input/TextArea"
import AWS from "aws-sdk"
import apisauce from "apisauce"
const { Option } = Select
AWS.config.update({ region: "us-east-1" })
const s3 = new AWS.S3()
const NewProductModal = (props) => {
	const [form] = Form.useForm()
	const [errorMessage, setErrorMessage] = useState("")
	const [files, setFileList] = useState([])
	const [progress, setProgress] = useState(0)
	const fileInput = useRef(null)
	const [product, setProduct] = useState({ name: null, description: null, file_hash: null })
	const [file, setFile] = useState(null)
	const [uploadId, setUploadId] = useState()
	const [headers, setHeaders] = useState()
	//const [partMap, setPartmap] = useState([]);
	useEffect(() => {
		setErrorMessage("")
		setProduct({ name: null, description: null, file_hash: null })
		form.resetFields()
	}, [props.newOrderVisible])

	useEffect(() => {
		form.resetFields()
		form.setFieldValue(product)
	}, [product])

	useEffect(() => {
		if (props.product) {
			API.getProduct(props.product).then((res) => {
				if (res.data.length > 0) setProduct(res.data[0])
			})
		}
	}, [props.product])

	const beforeUpload = (file) => {
		setFile(file)
		// Headers are required by Amazon S3
		setHeaders({
			"x-amz-acl": "public-read",
			"Content-Type": "application/zip, application/octet-stream",
		})
		return new Promise((resolve, reject) => {
			API.fileExists(file.name).then((res) => {
				//console.log(res.data.uploadId)
				if (res.data?.uploadId !== undefined) {
					setUploadId(res.data.uploadId)
					resolve()
				} else {
					setErrorMessage(`${file.name} already exists`)
					//message.error(`${file.name} already exists`);
					const newFileList = files.slice()
					newFileList.splice(0, 1)
					setFileList(newFileList)
					reject()
				}
			})
		})
	}
	const uploadChunk = async (formData, tryNum) => {
		if (tryNum <= 3) {
			try {
				console.log("chunk " + tryNum)
				let response = await API.uploadChunk(formData) // axios.post('/upload', formData);
				if (!response.ok) {
					return await uploadChunk(formData, tryNum + 1)
				}
				return response
			} catch (error) {
				console.log("retrying")
				return await uploadChunk(formData, tryNum + 1)
			}
		}
		return new Error("Upload failed")
	}
	const handleUpload = async ({ file, onSuccess, onError, onProgress }) => {
		if (!file) {
			message.error("Please select a file to upload")
			return
		}

		// Configure chunk size (e.g., 1MB)
		const chunkSize = 5 * (1024 * 1024)

		// Calculate the total number of chunks
		const totalChunks = Math.ceil(file.size / chunkSize)

		// Initialize variables for tracking progress
		let currentChunk = 1
		let startByte = 0
		let partMap = []
		while (currentChunk <= totalChunks) {
			onProgress({ percent: (currentChunk / totalChunks) * 100 }, file)
			const endByte = Math.min(startByte + chunkSize, file.size)

			// Slice the file into a chunk
			const chunk = file.slice(startByte, endByte)
			const formData = new FormData()
			formData.append("file", chunk)
			formData.append("chunk", currentChunk)
			formData.append("totalChunks", totalChunks)
			formData.append("filename", file.name)
			formData.append("uploadId", uploadId)

			// Upload the chunk to the server
			try {
				let response = await uploadChunk(formData, 1) // axios.post('/upload', formData);
				if (!response.ok) {
					onError("File upload failed")
					return
				}
				partMap.push(response.data)
				// Update progress or do something with the response
				const percent = (currentChunk / totalChunks) * 100
				//console.log(`Uploaded ${percent}%`);

				// Move to the next chunk
				startByte = endByte
				currentChunk++
			} catch (error) {
				console.error("Error uploading chunk:", error)
				message.error("Failed to upload file chunks")
				break // Exit the loop on error
			}
		}

		let data = {
			filename: file.name,
			uploadId: uploadId,
			partMap: partMap,
		}
		console.log(data)
		var result = await API.finishUpload(data)
		onSuccess("Upload complete")
		console.log(result)
		// Notify that the upload is complete
		message.success("File upload completed")
	}

	const resetState = () => {
		setProduct({ name: null, description: null, file_hash: null })
	}
	return (
		<Modal
			title={props.isEditing ? "Edit Product" : "Create Product"}
			visible={props.newOrderVisible}
			width={800}
			onCancel={() => {
				resetState()

				props.setNewProductVisible(false)
				props.clearSelectedProduct()
			}}
			onOk={() => {
				form
					.validateFields()
					.then((values) => {
						console.log(values)
						if (product.id) {
							values["id"] = product.id
							values.file_hash = values.file_hash.trim()

							API.updateProduct(values).then((res) => {
								if (res.ok) {
									resetState()
									// API.getProducts().then((res) => {
									// 	props.setProducts(res.data)
									props.setNewProductVisible(false)
									props.clearSelectedProduct()
									// })
								} else if (res.data.message.toLowerCase().includes("duplicate")) {
									setErrorMessage("A product already exists.")
								} else if (res.data.message.toLowerCase().includes("not found")) {
									setErrorMessage("File name/hash not found.")
								}
							})
						} else {
							values.name = values.name.trim()
							values.file_hash = values.file_hash.trim()

							API.createProduct(values).then((res) => {
								if (res.ok) {
									resetState()
									// API.getProducts().then((res) => {
									// 	props.setProducts(res.data)
									props.setNewProductVisible(false)
									props.clearSelectedProduct()
									// })
								} else if (res.data?.message?.toLowerCase().includes("duplicate")) {
									setErrorMessage(`${values.name} already exists`)
								} else if (res.data?.message?.toLowerCase().includes("not found")) {
									setErrorMessage(`File name/hash not found.`)
								}
							})
						}
					})
					.catch((info) => {
						console.log("Validate Failed:", info)
					})
			}}
		>
			<Form
				form={form}
				initialValues={product}
				disabled={product.id}
				labelCol={{
					span: 5,
				}}
				wrapperCol={{
					span: 19,
				}}
			>
				<Form.Item
					name="name"
					label="Product Name"
					rules={[
						{
							required: true,
							message: "'Product' is required",
						},
					]}
				>
					<Input maxLength={255} autoComplete="off" value={product.name} />
				</Form.Item>
				<Form.Item
					name="description"
					label="Description"
					rules={[
						{
							required: false,
						},
					]}
				>
					<TextArea value={product.description} />
				</Form.Item>
				{!product.id ? (
					<Form.Item
						name="fileName"
						label="File"
						valuePropName="File"
						rules={[
							{
								required: true,
								message: "'File' is required",
							},
						]}
					>
						<Upload
							//customRequest={handleFileUpload}
							headers={headers}
							//action={uploadUrl}
							customRequest={handleUpload}
							//action={`${process.env.REACT_APP_API_URL}upload`}
							onChange={(e) => {
								if (e.fileList.length === 0) form.setFieldsValue({ fileName: null });
							}}
							beforeUpload={beforeUpload}
							maxCount={1}
							listType="picture"
							multiple={false}
						>
							<Button icon={<UploadOutlined />}>Upload</Button>
						</Upload>
					</Form.Item>
					) : (
						<Form.Item
							name="filename"
							label="File Name"
							rules={[
								{
									required: true,
									message: "'File Name' is required",
								},
							]}
						>
							<Input maxLength={255} autoComplete="off" value={product.filename} />
						</Form.Item>
				)}
				<Form.Item
					name="file_hash"
					label="File Hash - SHA-256"
					rules={[
						{
							required: true,
							message: "'File Hash' is required",
						},
					]}
				>
					<Input maxLength={255} disabled={false} autoComplete="off" value={product.file_hash} />
				</Form.Item>
				{errorMessage.length > 0 && (
					<Alert
						style={{ marginBottom: 20 }}
						message={errorMessage}
						type="error"
						closable
						onClose={() => setErrorMessage("")}
					/>
				)}
			</Form>
		</Modal>
	)
}

export default NewProductModal
